import { render, staticRenderFns } from "./WithdrawalForm.vue?vue&type=template&id=39718f5d&lang=pug"
import script from "./WithdrawalForm.vue?vue&type=script&lang=js"
export * from "./WithdrawalForm.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalForm.vue?vue&type=style&index=0&id=39718f5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports